import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'searchField', 'category', 'service' ]

  connect() {
    this.hiddenClass = 'hidden'
  }

  handleSearch(e) {
    console.log($('body'))
    const search = e.currentTarget.value.toLowerCase()
    for (let index = 0; index < this.serviceTargets.length; index++) {
      const service = this.serviceTargets[index]
      const link = service.getElementsByTagName('a')[0]
      if (link.innerText.toLowerCase().indexOf(search) == -1) {
        service.classList.add(this.hiddenClass)
      } else {
        service.classList.remove(this.hiddenClass)
      }
    }
    for (let index = 0; index < this.categoryTargets.length; index++) {
      const category = this.categoryTargets[index]
      const services = category.querySelectorAll('li[data-prices-target="service"]').length
      const hiddenServices = category.querySelectorAll('li.hidden[data-prices-target="service"]').length
      if (services <= hiddenServices) {
        category.classList.add(this.hiddenClass)
      } else {
        category.classList.remove(this.hiddenClass)
      }
    }
  }

  search(e) {
    function delay(fn, ms) {
      let timer = 0
      return function(...args) {
        clearTimeout(timer)
        timer = setTimeout(fn.bind(this, ...args), ms || 0)
      }
    }

    let url = document.getElementById('prices_search').action
    let prices = document.querySelector('#prices')

    document.querySelector('#prices_search input').addEventListener('keyup', delay(function (e) {
      const params = new URLSearchParams({ search: this.value })
      fetch(`${url}?${params}`, {
        method: 'GET',
        headers: {
          accept: "application/json"
        }
      })
        .then(response => response.json())
        .then(data =>  prices.innerHTML = data.prices)
    }, 500));
  }

  searchButton(e){
    e.preventDefault()
    let url = document.getElementById('prices_search').action
    let prices = document.querySelector('#prices')
    let value = document.querySelector('#prices_search input').value
    const params = new URLSearchParams({ search: value })
    fetch(`${url}?${params}`, {
      method: 'GET',
      headers: {
        accept: "application/json"
      }
    })
      .then(response => response.json())
      .then(data =>  prices.innerHTML = data.prices)
  }
}
